import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from 'shared/locales/en/common.json';
import enError from 'shared/locales/en/error.json';
import viCommon from 'shared/locales/vi/common.json';

const resources = {
  en: {
    common: enCommon,
    error: enError,
  },
  vi: {
    common: viCommon,
    error: enError,
  },
};

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('i18nextLng') || 'en';

i18n.use(initReactI18next).init({
  lng: savedLanguage,
  fallbackLng: 'en',
  debug: process.env.NODE_ENV === 'development',
  ns: ['common', 'error'],
  defaultNS: 'common',
  resources,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
